import { render, staticRenderFns } from "./stockDetail.vue?vue&type=template&id=3cb04439&scoped=true&"
import script from "./stockDetail.vue?vue&type=script&lang=js&"
export * from "./stockDetail.vue?vue&type=script&lang=js&"
import style0 from "./stockDetail.vue?vue&type=style&index=0&id=3cb04439&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb04439",
  null
  
)

export default component.exports